import { ForbiddenError } from '@/domain/errors/forbidden-error'
import { Account } from '@/domain/usecases'
import { FeatureFlag } from '@/infra/feature-flag/feature-flag'
import {
  makeSkillWebManagerUsersRedirectUrl,
  makeSkillWebRequestsRedirectUrl
} from '@/main/factories/http'
import { LDClient } from 'launchdarkly-react-client-sdk'
import { QueryClient } from 'react-query'
import { redirect } from 'react-router-dom'
import PathConstants from '../path-contants'
import BaseLoader, { RecordsDefer } from './base-loader'

export default abstract class RegisteredPlanBaseLoader extends BaseLoader {
  constructor(
    readonly account: Account.Model,
    readonly queryClient: QueryClient,
    readonly ldClient: LDClient | undefined,
    readonly requiredFeatureFlag: FeatureFlag.Key | undefined = FeatureFlag.Key.DEFAULT_TRUE
  ) {
    super(account, PathConstants.Routes.ONBOADING.value, queryClient)
  }

  async defer(deferRecords: RecordsDefer) {
    const accountProfile = this.getAccount()
    if (!Account.hasPassPlan(accountProfile)) {
      return this.noPassPlanRedirect(accountProfile)
    }

    if (accountProfile.onboardingCompleted === false) {
      return this.notAllowedLoader.bind(this)()
    }

    const allowed = !this.requiredFeatureFlag || this.requiredFeatureFlag.getValue(this.ldClient)

    if (allowed) {
      return super.deferExec(deferRecords)
    }

    return this.fallbackRedirect.bind(this)()
  }

  private noPassPlanRedirect(accountProfile: Account.Model) {
    if (Account.isInternalCompanyManager(accountProfile)) {
      return redirect(makeSkillWebRequestsRedirectUrl())
    } else if (Account.isCompanyManager(accountProfile)) {
      return redirect(makeSkillWebManagerUsersRedirectUrl())
    } else {
      throw new ForbiddenError(
        'Para ter acesso ao benefício de educação, solicite ao responsável de sua empresa.',
        'Você ainda não possuí plano cadastrado'
      )
    }
  }
}
